import { render, staticRenderFns } from "./ModalInsertTask.vue?vue&type=template&id=683a0508&"
import script from "./ModalInsertTask.vue?vue&type=script&lang=js&"
export * from "./ModalInsertTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports